import api from "../../utils/api";

export const state = {
  _premiumSubscribe: [],
};

export const mutations = {
  setIsPremiumSubscribeAnalyzeInit(state, items) {
    state._premiumSubscribe = [];
    if (items) {
      state._premiumSubscribe = Object.assign([], items);
    }
  },
};

export const actions = {
  /**
   * 프리미엄 구독 리스트 조회
   * GET /api/v1/subscribe-premium
   */
  async acIsPremiumSubscribeAnalyze({ commit }) {
    try {
      const url = `/api/v1/subscribe-premium`;
      const res = await api.get(url);
      commit("setIsPremiumSubscribeAnalyzeInit", res.data.data);
      return true;
    } catch (error) {
      commit("setIsPremiumSubscribeAnalyzeInit", null);
      return false;
    }
  },

  /**
   * 프리미엄 구독 잔금일 변경
   * PATCH /api/v1/subscribe-premium/closing-date
   * @param {Object} params - { subscribe_seq, closing_date, converted }
   */
  async acUpdateClosingDate(_, params) {
    try {
      const res = await api.patch(`/api/v1/subscribe-premium/closing-date`, params);
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, message: error.response?.data?.message || error.message };
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
